import React from 'react'
import LogoFiestaCentered from './LogoFiestaCentered'
import LogoFiestaLeft from './LogoFiestaLeft'
import LogoFiestaRight from './LogoFiestaRight'

const SvgLogoFiestaUniversal = ({
  mainColor = '#2a0b0e',
  accentColor = '#f45115',
  lightColor = '#f5f5f5',
  alignment = 'centered',
  schema = 'dark',
  ...props
}) => {
  const colorSchema = {
    dark: {
      mainColor: mainColor,
      accentColor: accentColor,
    },
    light: {
      mainColor: lightColor,
      accentColor: accentColor,
    },
  }

  switch (alignment) {
    case 'centered':
      return (
        <LogoFiestaCentered
          mainColor={colorSchema[schema].mainColor}
          accentColor={colorSchema[schema].accentColor}
          {...props}
        />
      )
    case 'left':
      return (
        <LogoFiestaLeft
          mainColor={colorSchema[schema].mainColor}
          accentColor={colorSchema[schema].accentColor}
          {...props}
        />
      )
    case 'right':
      return (
        <LogoFiestaRight
          mainColor={colorSchema[schema].mainColor}
          accentColor={colorSchema[schema].accentColor}
          {...props}
        />
      )
    default:
      return (
        <LogoFiestaCentered
          mainColor={colorSchema[schema].mainColor}
          accentColor={colorSchema[schema].accentColor}
          {...props}
        />
      )
  }
}

export default SvgLogoFiestaUniversal
